export default function BuyMeACoffee() {
    return (
        <div className="bmc-container">
            <a href="https://www.buymeacoffee.com/sodkiewiczm" target="_blank" rel="noopener noreferrer">
                <img src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" alt="Buy Me A Coffee" className={"bmc-logo"}/>
            </a>
        </div>
    )
}